import { Directive, ElementRef, OnInit } from '@angular/core';

@Directive({
  selector: '[appAutofocus]', // Este será el nombre del atributo en el HTML
  standalone: false // Si usas Angular moderno (v14+), déjalo así. Si usas módulos, quítalo y declárala en tu NgModule.
})
export class AutofocusDirective implements OnInit {

  constructor(private el: ElementRef) {}

  ngOnInit() {
    // Un pequeño timeout de 0ms asegura que el input ya esté renderizado en el DOM
    setTimeout(() => {
      this.el.nativeElement.focus();
    }, 0);
  }
}